// extracted by mini-css-extract-plugin
export default {"tile":"tile___V4aQd","tileIcon":"tileIcon___DbDGg","tileLength":"tileLength___VvgWB","tileTitle":"tileTitle___sd3r5","data":"data___sds62"};